// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/Auth.css */

.auth-page {
  min-height: calc(100vh - 64px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
}

.auth-container {
  width: 100%;
  max-width: 380px;
  padding: 36px 32px;
  border-radius: var(--radius-lg);
  background: var(--surface);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-lg);
}

.auth-container h2 {
  text-align: center;
  margin-bottom: 6px;
  color: var(--text);
  font-size: 26px;
}

.auth-subtitle {
  text-align: center;
  color: var(--text-muted);
  font-size: 13px;
  margin: 0 0 26px;
}

.input-group {
  margin-bottom: 18px;
}

.input-group label {
  display: block;
  margin-bottom: 6px;
  color: var(--text-muted);
  font-size: 13px;
  font-weight: 500;
}

.input-group input {
  width: 100%;
  padding: 11px 14px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--bg-elevated);
  color: var(--text);
  font-size: 14px;
  transition: border-color var(--fast) var(--ease), box-shadow var(--fast) var(--ease);
}

.input-group input:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-soft);
}

.auth-button {
  width: 100%;
  padding: 12px;
  background: linear-gradient(120deg, var(--accent-start), var(--accent-end));
  color: #1a0e05;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  margin-top: 6px;
  transition: transform var(--fast) var(--ease), box-shadow var(--fast) var(--ease);
}

.auth-button:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-accent);
}

.auth-button:active {
  transform: translateY(0);
}

.auth-switch {
  text-align: center;
  color: var(--text-muted);
  font-size: 13px;
  margin: 20px 0 0;
}

.auth-switch a {
  color: var(--accent);
  font-weight: 600;
  text-decoration: none;
}

.auth-switch a:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Auth.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,oFAAoF;AACtF;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2EAA2E;EAC3E,cAAc;EACd,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iFAAiF;AACnF;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/* src/pages/Auth.css */\n\n.auth-page {\n  min-height: calc(100vh - 64px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n}\n\n.auth-container {\n  width: 100%;\n  max-width: 380px;\n  padding: 36px 32px;\n  border-radius: var(--radius-lg);\n  background: var(--surface);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-lg);\n}\n\n.auth-container h2 {\n  text-align: center;\n  margin-bottom: 6px;\n  color: var(--text);\n  font-size: 26px;\n}\n\n.auth-subtitle {\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 13px;\n  margin: 0 0 26px;\n}\n\n.input-group {\n  margin-bottom: 18px;\n}\n\n.input-group label {\n  display: block;\n  margin-bottom: 6px;\n  color: var(--text-muted);\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.input-group input {\n  width: 100%;\n  padding: 11px 14px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: var(--bg-elevated);\n  color: var(--text);\n  font-size: 14px;\n  transition: border-color var(--fast) var(--ease), box-shadow var(--fast) var(--ease);\n}\n\n.input-group input:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px var(--accent-soft);\n}\n\n.auth-button {\n  width: 100%;\n  padding: 12px;\n  background: linear-gradient(120deg, var(--accent-start), var(--accent-end));\n  color: #1a0e05;\n  border: none;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 600;\n  margin-top: 6px;\n  transition: transform var(--fast) var(--ease), box-shadow var(--fast) var(--ease);\n}\n\n.auth-button:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-accent);\n}\n\n.auth-button:active {\n  transform: translateY(0);\n}\n\n.auth-switch {\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 13px;\n  margin: 20px 0 0;\n}\n\n.auth-switch a {\n  color: var(--accent);\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.auth-switch a:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
